import { useCallback } from 'react'

import { useTribeClient } from '../../useTribeClient.js'
import { useAddToCachedParticipants } from './useAddToCachedParticipants.js'
import { useCachedParticipants } from './useCachedParticipants.js'

interface Props {
  chatId: string
}

export const useGetChatParticipantsByIds = ({ chatId }: Props) => {
  const { client } = useTribeClient()
  const { addToCachedParticipants } = useAddToCachedParticipants({
    chatId,
  })
  const { data: cachedParticipants } = useCachedParticipants({
    chatId,
  })

  const getChatParticipantsByIds = useCallback(
    async (ids: string[]) => {
      const particpantsToFetch = ids.filter(id => !cachedParticipants[id])
      if (particpantsToFetch.length === 0) {
        return []
      }

      try {
        const data = await client.messaging.chatParticipantsByIds({
          chatId,
          participantIds: particpantsToFetch,
        })
        addToCachedParticipants(data)
        return data
      } catch (error) {
        return []
      }
    },
    [chatId, cachedParticipants, client.messaging, addToCachedParticipants],
  )

  return {
    getChatParticipantsByIds,
  }
}
